import ENV from 'react-native-config';

import { SubtitlesFontSize } from 'store/player/reducer.types.ts';

import { isTablet } from 'utils/responsiveness.ts';

// Mocked testing live url;
export const LIVE_URL =
    'https://moctobpltc-i.akamaihd.net/hls/live/571329/eight/playlist.m3u8';

export const PAGE_TYPES = {
    MODULAR: 'modular_page',
    DEAFULT: 'default_page',
};

export const PAGES = {
    HELP: 'http://3ready.tv',
    FORGOT_PASSWORD: 'https://3ss.tv',
    SIGN_UP: 'https://3ready.tv/signup',
};

export const TIME_LANG_KEY = {
    PAST: 'CONTENT_MARKER_PAST',
    NOW: 'CONTENT_MARKER_NOW',
    FUTURE: 'CONTENT_MARKER_UPCOMING',
    NOT_SUBSCRIBED: 'CONTENT_MARKER_NOT_SUBSCRIBED',
    COMING_SOON: 'CONTENT_MARKER_COMING_SOON',
};

export const DEFAULT_STRIPE_SIZE = 20;

export const IMAGE_SERVER_BASE_URL = `${ENV.IMAGE_SERVER_BASE_URL}/images/v1/image`;

export const ANDROID_APP_ID = 'hu.one.onetv';
export const IOS_APP_ID = 'id6479893558';
export const IOS_APP_NAME = 'onetv';

export const WEB_SUBTITLES_EMBEDDED_PLAYER_FONT_SIZE = 10;
export const WEB_SUBTITLES_FULLSCREEN_PLAYER_FONT_SIZE = 20;

export const MOBILE_SUBTITLES_EMBEDDED_PLAYER_FONT_SIZE_MAP: Record<
    SubtitlesFontSize,
    number
> = {
    75: 12,
    100: 16,
    200: 20,
    300: 26,
};
export const MOBILE_SUBTITLES_FULLSCREEN_PLAYER_FONT_SIZE: Record<
    SubtitlesFontSize,
    number
> = isTablet
    ? {
          75: 20,
          100: 28,
          200: 34,
          300: 40,
      }
    : {
          75: 16,
          100: 22,
          200: 28,
          300: 34,
      };

export const OPF_RETRY_RESPONSE_STATUSES = [500, 502, 503, 504];
